import i18n from "../../../i18n";
const Entity = i18n.t('analytics.Entity');
const Failures = i18n.t('analytics.Failures');
const Successful = i18n.t('analytics.Successful');
const Total = i18n.t('analytics.Total');
const Type = i18n.t('analytics.Type');

export const TableHeaders = [
    {
        key: 'entity',
        header: Entity
    },
    {
        key: 'type',
        header: Type
    },
    {
        key: 'failures',
        header: Failures
    },
    {
        key: 'successful',
        header: Successful
    }, {
        key: 'total',
        header: Total
    }
];

export const MockData = [{
    entity: "abc",
    failures: "reason",
    mock1: "mock data",
    mock2: "mock data"
},
{
    entity: "xyz",
    failures: "reason 1",
    successful: "mock data 1",
    total: "mock data 1"
}]

export const abandonedProcessTrend = [
    {
        "body": {
            "took": 10,
            "timed_out": false,
            "_shards": {
                "total": 1,
                "successful": 1,
                "skipped": 0,
                "failed": 0
            },
            "hits": {
                "total": {
                    "value": 915,
                    "relation": "eq"
                },
                "max_score": null,
                "hits": []
            },
            "aggregations": {
                "incident_trend": {
                    "buckets": [
                        {
                            "key_as_string": "2022-08-10 00:00:00",
                            "key": 1656268200000,
                            "doc_count": 585,
                            "Month": {
                                "doc_count_error_upper_bound": 0,
                                "sum_other_doc_count": 0,
                                "buckets": [
                                    {
                                        "key": "August",
                                        "doc_count": 201
                                    },
                                    {
                                        "key": "September",
                                        "doc_count": 384
                                    }
                                ]
                            },
                            "incident_status": {
                                "doc_count_error_upper_bound": 0,
                                "sum_other_doc_count": 0,
                                "buckets": [
                                    {
                                        "key": "Total",
                                        "doc_count": 10
                                    }
                                ]
                            }
                        },
                        {
                            "key_as_string": "2022-08-24 00:00:00",
                            "key": 1656873000000,
                            "doc_count": 297,
                            "Month": {
                                "doc_count_error_upper_bound": 0,
                                "sum_other_doc_count": 0,
                                "buckets": [
                                    {
                                        "key": "August",
                                        "doc_count": 297
                                    }
                                ]
                            },
                            "incident_status": {
                                "doc_count_error_upper_bound": 0,
                                "sum_other_doc_count": 0,
                                "buckets": [
                                    {
                                        "key": "Total",
                                        "doc_count": 16
                                    },
                                    {
                                        "key": "Successful",
                                        "doc_count": 15
                                    },
                                    {
                                        "key": "In Progress",
                                        "doc_count": 20
                                    }
                                ]
                            }
                        },
                        {
                            "key_as_string": "2022-09-18 00:00:00",
                            "key": 1657477800000,
                            "doc_count": 33,
                            "Month": {
                                "doc_count_error_upper_bound": 0,
                                "sum_other_doc_count": 0,
                                "buckets": [
                                    {
                                        "key": "September",
                                        "doc_count": 33
                                    }
                                ]
                            },
                            "incident_status": {
                                "doc_count_error_upper_bound": 0,
                                "sum_other_doc_count": 0,
                                "buckets": [
                                    {
                                        "key": "Total",
                                        "doc_count": 15
                                    },
                                    {
                                        "key": "In Progress",
                                        "doc_count": 10
                                    },
                                    {
                                        "key": "Successful",
                                        "doc_count": 12
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
        },
        "statusCode": 200,
        "headers": {
            "x-elastic-product": "Elasticsearch",
            "content-type": "application/json; charset=UTF-8",
            "content-length": "1413"
        },
        "meta": {
            "context": null,
            "request": {
                "params": {
                    "method": "POST",
                    "path": "/indexed_servicenow/_search",
                    "body": "{\"aggs\":{\"incident_trend\":{\"date_histogram\":{\"field\":\"last_update_time\",\"calendar_interval\":\"1w\",\"time_zone\":\"Asia/Calcutta\",\"min_doc_count\":1},\"aggs\":{\"incident_status\":{\"terms\":{\"field\":\"incident_status.keyword\",\"order\":{\"_count\":\"desc\"},\"size\":10}},\"Month\":{\"terms\":{\"script\":{\"source\":\"if(!doc['last_update_time'].empty){\\n\\treturn new DateFormatSymbols().getMonths()[doc['last_update_time'].value.getMonthValue()-1];\\n} else {\\n\\treturn null;\\n}\",\"lang\":\"painless\"},\"order\":{\"_key\":\"desc\"},\"size\":10}}}}},\"size\":0,\"query\":{\"bool\":{\"must\":[{\"match_all\":{}},{\"match_all\":{}}],\"filter\":[{\"match_phrase\":{\"active\":{\"query\":true}}},{\"range\":{\"last_update_time\":{\"gte\":\"2022-06-29T12:25:15+05:30\",\"lte\":\"2022-09-29T12:25:15+05:30\",\"format\":\"strict_date_optional_time\"}}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}}],\"should\":[],\"must_not\":[]}}}",
                    "querystring": "",
                    "headers": {
                        "user-agent": "elasticsearch-js/7.17.0 (linux 4.15.0-189-generic-x64; Node.js v14.14.0)",
                        "content-type": "application/json; charset=utf-8",
                        "authorization": "Bearer 64O1AxZWU1lmb1JqS1JhYW41elFqQ19fQ213AAAAAAAAAAAA",
                        "x-elastic-client-meta": "es=7.17.0,js=14.14.0,t=7.17.0,hc=14.14.0",
                        "content-length": "1135"
                    },
                    "timeout": 15000
                },
                "options": {},
                "id": 1
            },
            "name": "elasticsearch-js",
            "connection": {
                "url": "https://10.113.83.94:9200/",
                "id": "https://10.113.83.94:9200/",
                "headers": {},
                "deadCount": 0,
                "resurrectTimeout": 0,
                "_openRequests": 0,
                "status": "alive",
                "roles": {
                    "master": true,
                    "data": true,
                    "ingest": true,
                    "ml": false
                }
            },
            "attempts": 0,
            "aborted": false
        }
    }
]

export const topFailureCategories = [
    {
        "body": {
            "took": 129,
            "timed_out": false,
            "_shards": {
                "total": 1,
                "successful": 1,
                "skipped": 0,
                "failed": 0
            },
            "hits": {
                "total": {
                    "value": 54,
                    "relation": "eq"
                },
                "max_score": null,
                "hits": []
            },
            "aggregations": {
                "2": {
                    "doc_count_error_upper_bound": 0,
                    "sum_other_doc_count": 0,
                    "buckets": [
                        {
                            "key": "Broker Sessions",
                            "doc_count": 25
                        },
                        {
                            "key": "Input File Missing",
                            "doc_count": 12
                        },
                        {
                            "key": "http Error",
                            "doc_count": 20
                        },
                        {
                            "key": "Index Out of Bound",
                            "doc_count": 4
                        },
                        {
                            "key": "Invalid Data Format",
                            "doc_count": 9
                        },
                        {
                            "key": "ID Mismatch",
                            "doc_count": 13
                        },
                        {
                            "key": "Others",
                            "doc_count": 17
                        }
                    ]
                }
            }
        },
        "statusCode": 200,
        "headers": {
            "x-elastic-product": "Elasticsearch",
            "warning": "299 Elasticsearch-7.16.2-2b937c44140b6559905130a8650c64dbd0879cfb \"Use of the joda time method [getMillis()] is deprecated. Use [toInstant().toEpochMilli()] instead.\"",
            "content-type": "application/json; charset=UTF-8",
            "content-length": "534"
        },
        "meta": {
            "context": null,
            "request": {
                "params": {
                    "method": "POST",
                    "path": "/automataactivity/_search",
                    "body": "{\"aggs\":{\"2\":{\"terms\":{\"field\":\"automata_name.keyword\",\"order\":{\"_count\":\"desc\"},\"size\":100}}},\"size\":0,\"query\":{\"bool\":{\"must\":[{\"match_all\":{}},{\"match_all\":{}}],\"filter\":[{\"match_phrase\":{\"active\":{\"query\":true}}},{\"range\":{\"last_update_time\":{\"gte\":\"2022-03-29T13:24:53+05:30\",\"lte\":\"2022-09-29T13:24:53+05:30\",\"format\":\"strict_date_optional_time\"}}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"bool\":{\"should\":[],\"minimum_should_match\":1}},{\"script\":{\"script\":{\"source\":\"boolean compare(Supplier s, def v) {return s.get() == v;}compare(() -> { def diff=0;\\ndef st_time=0;\\nif((!doc['automata_status.keyword'].empty) && (!doc['standard_exectution_time'].empty) && (doc['standard_exectution_time'].value >0))\\n{\\n\\t st_time = doc['standard_exectution_time'].value*60*1000;\\n\\tif((!doc['automata_create_time'].empty) && (!doc['automata_status.keyword'].empty) && (doc['automata_status.keyword'].value == \\\"Pending\\\"))\\n\\t{\\n\\t\\t\\tdiff = new Date().getTime() - doc['automata_create_time'].value.getMillis(); \\n\\t}\\n\\telse if((!doc['automata_start_time'].empty) && (!doc['automata_status.keyword'].empty) && (doc['automata_status.keyword'].value == \\\"Running\\\")) \\n\\t{\\n\\t\\t\\tdiff = new Date().getTime() - doc['automata_start_time'].value.getMillis(); \\n\\t}\\n\\telse {\\n    if(!doc['automata_start_time'].empty &&  !doc['automata_end_time'].empty)\\n\\t{\\n\\t\\tdiff = doc['automata_end_time'].value.getMillis() - doc['automata_start_time'].value.getMillis(); \\n\\t}\\n\\t}\\n\\tif(diff > st_time){\\n\\t\\treturn true;   \\n\\t}\\n\\telse{\\n\\t\\treturn false;   \\n\\t}\\n}\\nelse\\n{\\nreturn false;\\n} }, params.value);\",\"lang\":\"painless\",\"params\":{\"value\":true}}}}],\"should\":[],\"must_not\":[{\"match_phrase\":{\"doc_type.keyword\":{\"query\":\"master_data\"}}}]}}}",
                    "querystring": "",
                    "headers": {
                        "user-agent": "elasticsearch-js/7.17.0 (win32 10.0.22000-x64; Node.js v14.16.0)",
                        "content-type": "application/json; charset=utf-8",
                        "authorization": "Bearer 64O1AxZDR01RblNDeFRhU3AwOGFkb1BvZXd3AAAAAAAAAAAA",
                        "x-elastic-client-meta": "es=7.17.0,js=14.16.0,t=7.17.0,hc=14.16.0",
                        "content-length": "1885"
                    },
                    "timeout": 15000
                },
                "options": {},
                "id": 1
            },
            "name": "elasticsearch-js",
            "connection": {
                "url": "https://10.113.83.94:9200/",
                "id": "https://10.113.83.94:9200/",
                "headers": {},
                "deadCount": 0,
                "resurrectTimeout": 0,
                "_openRequests": 0,
                "status": "alive",
                "roles": {
                    "master": true,
                    "data": true,
                    "ingest": true,
                    "ml": false
                }
            },
            "attempts": 0,
            "aborted": false
        }
    }
]

